<template>
  <div class="search-bar">
    <div class="search-container">
      <div class="search">
        <div class="search-items" :style="{width:searchWidth + 'px'}">
          <div class="search-title" v-if="titleArr.includes(title)">{{ title }}</div>
          <el-select
            v-model="formData.dateValue"
            placeholder="请选择"
            class="select"
            v-if="title =='统计概要'"
          >
            <el-option
              v-for="item in dateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div
            class="input-container"
            v-if="title =='统计概要' || title =='代理列表' || title =='佣金列表' || title =='渠道管理' || title =='会员列表'"
          >
            <span>代理账号</span>
            <el-input v-model="formData.agentAccount" placeholder="请输入代理账号"></el-input>
          </div>

          <div
            class="input-container"
            v-if="title =='统计概要' || title =='代理列表'  || title =='佣金列表' || title =='渠道管理'"
          >
            <span class="agent-name">代理名称</span>
            <el-input v-model="formData.agentName" placeholder="请输入代理名称"></el-input>
          </div>

          <div class="input-container" v-if="title =='数据趋势'">
            <div class="input-content">
              <span class="accout-span">添加对比1</span>
              <el-select v-model="formData.compareValue1" filterable placeholder="请选择" class="select">
                <el-option
                  v-for="item in agentList"
                  :key="item.id"
                  :label="item.userAccout"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="input-container" v-if="title =='数据趋势'">
            <div class="input-content">
              <span class="accout-span">添加对比2</span>
              <el-select v-model="formData.compareValue2" filterable placeholder="请选择" class="select">
                <el-option
                  v-for="item in agentList"
                  :key="item.id"
                  :label="item.userAccout"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="input-container" v-if="title =='会员列表'">
            <span class="agent-name">用户名称</span>
            <el-input v-model="formData.userName" placeholder="请输入账号名称"></el-input>
          </div>

          <!-- <div
            class="input-container"
            v-if="title !=='渠道管理' &&  title !=='账户管理' && title !=='代理列表'"
          >
            <span>渠道</span>
            <el-select v-model="formData.sourceValue" placeholder="请选择" class="select">
              <el-option
                v-for="item in sourceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->

          <div class="input-container" v-if="title=='渠道管理'">
            <span>状态</span>
            <el-select v-model="stateValue" placeholder="请选择" class="select">
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="input-container" v-if="title =='代理列表' || title =='会员列表'">
            <span>{{ title =='会员列表' ? '会员盈亏' :'盈亏' }}</span>
            <el-select v-model="formData.isWin" placeholder="请选择" class="select">
              <el-option
                v-for="item in incomeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="input-container" v-if="title !=='账户管理'">
            <span>筛选</span>
            <el-date-picker
              class="date-picker"
              v-model="formData.startAndEndValue"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>

          <!-- <div class="input-container" v-if="title =='会员列表'">
            <span>充值</span>
            <el-select v-model="formData.depositValue" placeholder="请选择" class="select">
              <el-option
                v-for="item in depositOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->

          <!-- <div class="input-container" v-if="title =='代理列表'">
            <span class="agent-name">归属人</span>
            <el-select v-model="formData.belongingValue" placeholder="请选择归属人" class="select">
              <el-option
                v-for="item in belongingOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->

          <div class="input-container" v-if="title =='账户管理'">
            <span class="agent-name">用户ID</span>
            <el-input v-model="formData.agentNameValue" placeholder="请输入账号名称"></el-input>
          </div>

          <!-- <div class="input-container" v-if="title =='账户管理'">
            <span>角色</span>
            <el-select v-model="formData.roleValue" placeholder="选择角色" class="select">
              <el-option
                v-for="item in roleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->

          <div class="input-container" v-if="title =='账户管理'">
            <span>状态</span>
            <el-select v-model="formData.accoutStateValue" placeholder="选择状态" class="select">
              <el-option
                v-for="item in accoutStateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="btns" :style="{width: title=='代理列表'?'400px':''}">
          <el-button round v-if="title=='代理列表'" @click="handleAddNewAgent">新增</el-button>
          <!-- <el-button round v-if="title=='代理列表'">导出</el-button> -->
          <el-button round @click="handleClearAll">清空</el-button>
          <el-button round type="primary" @click="handleQuery">查询</el-button>
          <el-button v-if="title==='账户管理'" @click="handleAddNewAdmin" round type="primary">新增管理员</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatTime,
  getThisMonth,
  formaTommorrowTime,
} from "@/utills/formatTime.js";
import { Message } from "element-ui";
import { apiGetAgentList } from "@/api/userApi";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    searchWidth: {
      type: Number | null,
      default: null,
    },
  },
  data() {
    return {
      dateOptions: [
        {
          value: "1",
          label: "今日",
        },
        {
          value: "2",
          label: "7日",
        },
        {
          value: "3",
          label: "30日",
        },
      ],
      compareOptions: [
        {
          value: "1",
          label: "01",
        },
        {
          value: "2",
          label: "02",
        },
        {
          value: "3",
          label: "03",
        },
        {
          value: "4",
          label: "04",
        },
        {
          value: "5",
          label: "05",
        },
        {
          value: "6",
          label: "06",
        },
      ],
      sourceOptions: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "01",
        },
        {
          value: "2",
          label: "02",
        },
        {
          value: "3",
          label: "03",
        },
      ],
      incomeOptions: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "盈利",
        },
        {
          value: "2",
          label: "亏损",
        },
      ],

      belongingOptions: [
        {
          value: "star",
          label: "star",
        },
        {
          value: "凯文",
          label: "凯文",
        },
      ],
      depositOptions: [
        {
          value: "1",
          label: "首充",
        },
        {
          value: "2",
          label: "二次充值",
        },
      ],
      stateOptions: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "未使用",
        },
        {
          value: "2",
          label: "正在使用",
        },
      ],

      roleOptions: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "超级管理员",
        },
        {
          value: "2",
          label: "管理员",
        },
      ],
      accoutStateOptions: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "2",
          label: "关闭",
        },
        {
          value: "1",
          label: "开启",
        },
      ],

      formData: {
        dateValue: "1",
        agentAccount: "",
        compareValue1: 0,
        compareValue2: null,
        isWin: "0",
        agentName: "",
        accuntIDValue: "",
        startAndEndValue: "",
        depositValue: "1",
        stateValue: "0",
        roleValue: "0",
        accoutState: "0",
        accoutStateValue: "0",
        userName:""
      },
      agentList: [
        {
          id: 0,
          userAccout: "官方",
        },
      ],

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      startAndEndValue: "",

      titleArr: ["统计概要", "数据趋势"],
    };
  },

   async mounted(){
    if (this.title==='数据趋势') {
     const res  = await this.sendApiGetAgentList()
     if (res.success) {
      this.agentList = [...this.agentList , ...res.data]
     }
    }
  },
  methods: {
    handleQuery() {

      if (this.$route.path === "/agency-list") {
        const data = {
          agentAccount: this.formData.agentAccount,
          agentName: this.formData.agentName,
          isWin: +this.formData.isWin,
          beginTime: "",
          endTime: "",
        };
        if (this.formData.startAndEndValue.length) {
          data.beginTime = formatTime(this.formData.startAndEndValue[0]);
          data.endTime = formatTime(this.formData.startAndEndValue[1]);
        } else {
          data.beginTime = getThisMonth(Date.now()).firstDatOfMonth;
          data.endTime = getThisMonth(Date.now()).lastDatOfMonth;
        }

        this.$emit("handleAgencyList", data);
      } else if (this.$route.path === "/commission-report") {
        const data = {
          agentAccount: this.formData.agentAccount,
          agentName: this.formData.agentName,
          isWin: +this.formData.isWin,
          beginTime: "",
          endTime: "",
        };

        if (this.formData.startAndEndValue.length) {
          data.beginTime = formatTime(this.formData.startAndEndValue[0]);
          data.endTime = formatTime(this.formData.startAndEndValue[1]);
        } else {
          data.beginTime = getThisMonth(Date.now()).firstDatOfMonth;
          data.endTime = getThisMonth(Date.now()).lastDatOfMonth;
        }

        this.$emit("handleCommissionList", data);
      } else if (this.$route.path === "/system-setting/account-manage") {
        const data = {
          nickName: this.formData.agentNameValue,
          usersStatus: +this.formData.accoutStateValue,
        };
        this.$emit("handleUserList", data);
      } else if (this.$route.path === "/data-overview") {
        const data = {
          agenNickName: this.formData.agentName,
          agentAccount: this.formData.agentAccount,
          beginTime: "",
          endTime: "",
        };

        if (this.formData.startAndEndValue.length) {
          data.beginTime = formatTime(this.formData.startAndEndValue[0]);
          data.endTime = formatTime(this.formData.startAndEndValue[1]);
        } else {
          if (this.formData.dateValue == "1") {
            data.beginTime = formatTime(Date.now());
            data.endTime = formaTommorrowTime(Date.now());
          } else if (this.formData.dateValue == "2") {
            data.beginTime = formaTommorrowTime(Date.now(), -7);
            data.endTime = formatTime(Date.now());
          } else if (this.formData.dateValue == "3") {
            data.beginTime = formaTommorrowTime(Date.now(), -30);
            data.endTime = formatTime(Date.now());
          }
        }

        this.$emit("handleQueryDataView", data);
      } else if (this.$route.path === "/user-list") {
        const data = {
          userName: this.formData.userName,
          agentAccount: this.formData.agentAccount,
          isWin: +this.formData.isWin,
        };
        if (this.formData.startAndEndValue.length) {
          data.beginTime = formatTime(this.formData.startAndEndValue[0]);
          data.endTime = formatTime(this.formData.startAndEndValue[1]);
        } else {
          data.beginTime = getThisMonth(Date.now()).firstDatOfMonth;
          data.endTime = getThisMonth(Date.now()).lastDatOfMonth;
        }
        this.$emit("handleQueryUserInfo", data);
      }
      
      
       if (this.$route.path === "/data-overview" && this.title ==='数据趋势') {
        // if (!this.formData.compareValue2)  return Message.error('请选择添加对比2')
        let compareValue1Name1
        let compareValue1Name2

        this.agentList.forEach(el => {
          if (el.id === this.formData.compareValue1 ) {
            compareValue1Name1 = el.userAccout
          }

          if (el.id === this.formData.compareValue2 ) {
            compareValue1Name2 = el.userAccout
          }
        });
        
         const data  = {
          compareValue1:this.formData.compareValue1,
          compareValue2:this.formData.compareValue2,
          compareValue1Name1,
          compareValue1Name2
        }
        if (this.formData.startAndEndValue.length) {
          data.beginTime = formatTime(this.formData.startAndEndValue[0]);
          data.endTime = formatTime(this.formData.startAndEndValue[1]);
        } else {
          data.beginTime = formatTime(Date.now());
          data.endTime = formaTommorrowTime(Date.now());
        }

        console.log('data',data);

        this.$emit("handleAgentCompare", data);
      }
    },

    handleAddNewAdmin() {
      this.$emit("handleAddNewAdmin", { bool: true, title: "新增" });
    },

    handleClearAll() {
      this.formData.agentNameValue = "";
      this.formData.accoutStateValue = "0";
      this.formData.startAndEndValue = [];
      this.formData.agentAccount = "";
      this.formData.agentName = "";
      this.formData.userName = "";
      this.formData.isWin = "0";
      this.formData.dateValue = "1";
      this.formData.accuntIDValue = "";
      this.formData.depositValue = "1";
      this.formData.compareValue1 = ""
      this.formData.compareValue2 = null
    },

    handleAddNewAgent() {
      this.$emit("handleAddNewAgent", { bool: true, title: "新增代理" });
    },

    async sendApiGetAgentList() {
      try {
        const res = await apiGetAgentList();
        if (res.success) {

          console.log('res~~' ,res);
          return res;
        }
      } catch (error) {
        Message.error("查询失败");
        console.log("error", error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-bar {
  border-top: 1px solid #ccc6c6;
  .search {
    background: #333;
    margin-top: 10px;
    display: flex;
    align-items: center;
    color: #fff;
    min-height: 80px;
    justify-content: space-between;

    .search-items {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .search-title {
      width: 100px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }

    .input-container {
      display: flex;
      align-items: center;
      margin: 10px 0;
      span {
        padding: 0 10px;
      }

      .date-picker {
        width: 280px;
      }

      .el-input {
        width: 150px;
      }
    }

    .btns {
      margin-left: 20px;
      min-width: 200px;
    }

    .select {
      width: 100px;
    }
  }
}
</style>